const Report = () =>
  import(
    /* webpackChunkName: "courier-license" */ '@/pages/courier/license/index.vue'
  )
const Create = () =>
  import(
    /* webpackChunkName: "courier-license" */ '@/pages/courier/license/create.vue'
  )
const Edit = () =>
  import(
    /* webpackChunkName: "courier-license" */ '@/pages/courier/license/edit.vue'
  )

export default {
  path: 'license',
  meta: {
    label: 'licenses',
    auth: 'license'
  },
  component: {
    name: 'License',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'CompanyLicenseReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report,
      props: true
    },
    {
      name: 'CompanyCreateLicense',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    },
    {
      name: 'CompanyEditLicense',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: Edit,
      props: true
    }
  ]
}
